import React, { useState } from 'react';
import { Calendar, Filter, Check, MessageCircle, Heart } from 'lucide-react';

const timeFilters = [
  { label: 'Last Hour', value: 'hour' },
  { label: 'Last 24 hours', value: 'day' },
  { label: 'Last 3 days', value: '3days' },
  { label: 'Last week', value: 'week' },
  { label: 'Last month', value: 'month' },
  { label: 'All time', value: 'all' }
];

const typeFilters = [
  { label: 'All', value: 'all', icon: Filter },
  { label: 'Feature Choices', value: 'response', icon: Check },
  { label: 'Comments', value: 'comment', icon: MessageCircle },
  { label: 'Reactions', value: 'reaction', icon: Heart }
];

const ActivityFilters = ({ onTimeFilterChange, onTypeFilterChange }) => {
  const [timeFilter, setTimeFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');

  const handleTimeFilterChange = (value) => {
    setTimeFilter(value);
    onTimeFilterChange(value);
  };

  const handleTypeFilterChange = (value) => {
    setTypeFilter(value);
    onTypeFilterChange(value);
  };

  return (
    <div className="p-4 border-b flex flex-wrap gap-4">
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-gray-500" />
        <div className="flex flex-wrap gap-2">
          {timeFilters.map(filter => (
            <button
              key={filter.value}
              onClick={() => handleTimeFilterChange(filter.value)}
              className={`px-3 py-1 rounded-md text-sm font-medium transition-colors
                ${timeFilter === filter.value
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Filter className="w-4 h-4 text-gray-500" />
        <div className="flex gap-2">
          {typeFilters.map(filter => (
            <button
              key={filter.value}
              onClick={() => handleTypeFilterChange(filter.value)}
              className={`px-3 py-1 rounded-md text-sm font-medium transition-colors flex items-center gap-1
                ${typeFilter === filter.value
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              <filter.icon className="w-4 h-4" />
              {filter.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ActivityFilters;